<template>
  <!-- Column container -->
  <div class="z-5 w-full pt-8 max-w-7xl mx-auto">
    <!-- One Column -->
    <main
      id="main"
      tabindex="-1"
      class="flex flex-col w-full h-auto xl:px-8 px-4 mx-auto items-center"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
// Navigation is now handled at the App.vue level
// No need to import or render navigation here
</script>

<style scoped>
.ua-base-1-column,
.ua-base-1-column .ua-base-column_container,
.ua-base-1-column body,
.ua-base-1-column main {
  height: 100%;
}
</style>
